export default "__VITE_ASSET__mwiiWdT2__"